import styled from 'styled-components/macro'

export const DetailsRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: right;
  gap: 16px;

  p {
    opacity: 0.8;
    padding: 0;
    margin: 0;
    text-align: left;
    white-space: nowrap;
  }
`
